export function showError (mesg, type) {
  this.$message({
    type: type || 'error',
    message: mesg || '出错了'
  })
}
